export default __webpack_public_path__ + "static/media/Points-Icon.e46415ac.svg";